<template>
  <div>
    <el-dialog
      title="新增用户"
      :visible.sync="createVisible"
      width="30%"
      :before-close="handleClose"
    >
      <el-form :model="form" :rules="rules" ref="form">
        <!-- <el-form-item label="ID" :label-width="formLabelWidth" prop="id">
          <el-input v-model="form.id" autocomplete="off"></el-input>
        </el-form-item> -->
        <el-form-item label="邮箱" :label-width="formLabelWidth" prop="email">
          <el-input
            v-model="form.email"
            placeholder="请输入邮箱地址"
          ></el-input>
        </el-form-item>
        <el-form-item label="密码" :label-width="formLabelWidth" prop="pwd">
          <el-input v-model="form.pwd" placeholder="请输入密码"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialod('form')">取 消</el-button>
        <el-button type="primary" @click="add('form')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";

export default {
  data() {
    return {
      dialogFormVisible: false,
      formLabelWidth: "80px",
      form: {
        // id: "",
        email: "",
        pwd: "",
      },
      rules: {
        id: [{ required: true, message: "请输入ID", trigger: "blur" }],
        email: [{ required: true, message: "请输入邮箱地址", trigger: "blur" }],
        // pwd: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
    };
  },
  computed: {
    ...mapState("userOld", ["createVisible"]),
  },
  methods: {
    ...mapMutations("userOld", ["setCreateVisible"]),
    ...mapActions('userOld',['addUser']),
    add(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.addUser({...this.form}).then(res=>{
            if(res.code==0){
                this.$message.success('添加成功')
                this.setCreateVisible(false);
            }else{
                this.$message.error(res.msg)
            }
          })
         
        } else {
            this.$message.error('操作失败')
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    closeDialod(formName) {
      this.resetForm(formName);
      this.setCreateVisible(false);
    },
    handleClose(done) {
        this.$confirm('确认关闭？')
          .then(_ => {
            this.setCreateVisible(false);
            done();
          })
          .catch(_ => {
          
          });
      }
  },
};
</script>

<style lang="less" scoped></style>
